import axios from "axios";
import {
  BUSINESS_CATEGORY_URL,
  BUSINESS_LIST_GET,
  BUSINESS_LIST_PUT,
  BUSINESS_STATS,
  BUSINESS_TRANSACTION_DETAILS,
  BUSINESS_TRANSACTION_GET,
  BUSINESS_URL,
  DELETE_USER,
  MASTER_URL,
  OTP_CONFIRM_URL_TEMPLATE,
  RESEND_OTP_URL_TEMPLATE,
} from "./const";
import * as USER_ACTION from "../features/business/userSlice";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getBusinessCategories = async () => {
  try {
    const response = await axios.get(BUSINESS_CATEGORY_URL);
    const businessCategories = response.data.content.category;
    return businessCategories;
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

export async function fetchFromMaster() {
  const response = await axios.get(MASTER_URL);
  return await response.data.content.masters;
}

export function confirmOtp(username, otp) {
  // Support both confirmOtp(username, otp) and confirmOtp({ username, otp })
  const u = typeof username === "object" ? username?.username : username;
  const o = typeof username === "object" ? username?.otp : otp;
  const payLoad = { username: encodeURIComponent(u || ""), otp: encodeURIComponent(o || "") };
  const otp_confirm_url = OTP_CONFIRM_URL_TEMPLATE(payLoad);
  return axios.post(otp_confirm_url);
}

export function resendOtp(username) {
  const u = typeof username === "object" ? username?.username : username;
  const payLoad = { username: encodeURIComponent(u || "") };
  const resend_otp_url = RESEND_OTP_URL_TEMPLATE(payLoad);
  return axios.post(resend_otp_url);
}

export function createBusiness(data) {
  return axios.post(BUSINESS_URL, data);
}


export const getBusinessList = (rowsPerPage, page, token, startEpoch, endEpoch, userId) => {
  return dispatch => {
      dispatch(USER_ACTION.isStarted_GetBusinessList());

      let urlParams = `?page=${page}&size=${rowsPerPage}`;
      urlParams = userId ? urlParams + "&userId=" + userId : urlParams;

      let apiUrl = new URL(BUSINESS_LIST_GET + urlParams);

      fetch(apiUrl, {
          method: "GET",
          headers: {
              'Authorization': `Bearer ${token}`,
          },
      }).then(res => {
          if (res.status === 401) {
              window.location = "/login";
          } else {
              return res.json();
          }
      }).then(data => {
          if (data && 'content' in data) {
              if (data.content && 'businesses' in data.content) {
                  let { pagination, businesses } = data.content;
                  let tempPagination = {
                      totalRows: pagination.totalElements,
                      totalPages: pagination.totalPages,
                      currentPage: pagination.page
                  }
                  let temp = { payload: businesses, pagination: tempPagination };
                  return dispatch(USER_ACTION.success_GetBusinessList({ ...temp }));
              } else {
                  let temp = { payload: data['content'].businesses, pagination: {} };
                  return dispatch(USER_ACTION.success_GetBusinessList({ ...temp }));
              }
          } else {
              if (data && 'message' in data) {
                  return dispatch(USER_ACTION.error_GetBusinessList(data.message));
              } else {
                  return dispatch(USER_ACTION.error_GetBusinessList('Server error'));
              }
          }
      }).catch(error => {
          dispatch(USER_ACTION.error_GetBusinessList("Server error"));
      });
  }
}

export const getBusinessStats = (businessId, startEpoch, endEpoch, token) => {
  return dispatch => {
      dispatch(USER_ACTION.isStarted_GetBusinessStats());
      var urlParams = '';
      urlParams = businessId != 0 ? '&businessTypeId=' + businessId + urlParams : urlParams;
      // urlParams = startEpoch ? '&startDate='+startEpoch + urlParams : urlParams;
      // urlParams = endEpoch != "" ? '&endDate='+endEpoch + urlParams : urlParams;

      var apiUrl = new URL(BUSINESS_STATS + (urlParams != '' ? '?' + urlParams : ''));

      // var apiUrl = new URL(BUSINESS_STATS + '?'+ '&startDate='+startEpoch+'&endDate='+endEpoch+'&businessTypeId='+businessId);
      //apiUrl.search = new URLSearchParams(obj).toString();
      fetch(apiUrl, {
          // credentials:"include",
          method: "GET",
          headers: {
              'Authorization': `Bearer ${token}`, // notice the Bearer before your token
          },
      }).then(res => {
          if (res.status === 401) {
              window.location = "/login";
          } else {
              return res.json();
          }
      })
          .then(data => {
              // console.log("API RESPONSE getMyProfile: ", data);
              return dispatch(USER_ACTION.success_GetBusinessStats(data.content));
          }).catch(error => {
              //console.error("ERROR IN getMyProfile API: ", error)
              dispatch(USER_ACTION.error_GetBusinessStats("Server error" + error));
          });
  }
}

export const updateBusiness = (reqObj, visitId, token) => {
  // console.log("HITTING - addComment", token);
  // let {visitId, role, userName, reviewComment } = reqObj;
  return dispatch => {
      dispatch(USER_ACTION.isStarted_UpdateBusiness());
      // console.log(JSON.stringify(reqObj));

      // let newURL = SEND_COMMENTS_MAIL.replace("{visitId}", visitId);
      // var apiUrl = new URL(newURL);
      var apiUrl = new URL(BUSINESS_STATS);
      //apiUrl.search = new URLSearchParams(obj).toString();
      fetch(apiUrl, {
          // credentials:"include",
          method: "POST",
          headers: {
              'Authorization': `Bearer ${token}`, // notice the Bearer before your token
              "Content-Type": "application/json"
          },
          body: JSON.stringify(reqObj)
      }).then(res => {
          if (res.status === 401) {
              window.location = "/login";
          } else {
              return res;
          }
      }).then(data => {
          // console.log("API RESPONSE sendEmailComment: ", data);
          if (data && data.status === 200) {
              dispatch(USER_ACTION.success_UpdateBusiness('Successfully sent email..'));
          }
          else {
              // console.log("Error: ", data);
              if (data && 'message' in data) {
                  //alert(`Error: ${data.message}`);
                  dispatch(USER_ACTION.error_UpdateBusiness(data.message));
              } else {
                  dispatch(USER_ACTION.error_UpdateBusiness('Server error1'));
              }
          }
      }).catch(error => {
          //console.error("ERROR IN addComment API: ", error)
          dispatch(USER_ACTION.error_UpdateBusiness('Error'));

      });
  }
}

export const fetchTransactionsThunk = createAsyncThunk(
    "transactions/fetchTableData",
    async (params, { rejectWithValue }) => {
        const { token, page, size, searchParameter, sortDirection, startEpoch, endEpoch, filterByStatus, filterByType, userId } = params;
        try {
            let urlParams = `?page=${page ?? 0}&size=${size ?? 10}`;
            if (searchParameter && searchParameter.trim() !== "") {
                urlParams += `&searchParameter=${encodeURIComponent(searchParameter.trim())}`;
            }
            if (sortDirection && sortDirection !== "") {
                urlParams += `&sortDirection=${sortDirection}`;
            }
            if (startEpoch && startEpoch !== "") {
                urlParams += `&startEpoch=${startEpoch}`;
            }
            if (endEpoch && endEpoch !== "") {
                urlParams += `&endEpoch=${endEpoch}`;
            }
            if (filterByStatus && filterByStatus !== "") {
                urlParams += `&filterByStatus=${filterByStatus}`;
            }
            if (filterByType && filterByType !== "") {
                urlParams += `&filterByType=${filterByType}`;
            }
            if (userId && userId !== "") {
                urlParams += `&userId=${userId}`;
            }

            const apiUrl = BUSINESS_TRANSACTION_GET + urlParams;
            const response = await fetch(apiUrl, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                const errData = await response.json().catch(() => null);
                // Backend throws 400 when no transactions match or results are empty
                if (response.status === 400 || (errData?.message && errData.message.toLowerCase().includes("not found"))) {
                    return {
                        payload: {
                            content: {
                                businesses: [],
                                pagination: { totalElements: 0, totalPages: 1, page: page || 0, size: size || 10 },
                            },
                        },
                        pagination: {
                            totalRows: 0,
                            totalPages: 1,
                            currentPage: page || 0,
                        },
                    };
                }
                throw new Error(errData?.message || "Failed to fetch data");
            }

            const data = await response.json();
            return {
                payload: data,
                pagination: {
                    totalRows: data.content?.pagination?.totalElements || 0,
                    totalPages: data.content?.pagination?.totalPages || 1,
                    currentPage: data.content?.pagination?.page || 0,
                },
            };
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchTransactionDetailsThunk = createAsyncThunk(
    "transactionDetails/fetchTransactionDetails",
    async (params, { rejectWithValue }) => {
        const { token, transactionId } = params;
        try {
            let urlParams = `?transactionId=${transactionId}`;
            const apiUrl = BUSINESS_TRANSACTION_DETAILS + urlParams;

            const response = await fetch(apiUrl, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (!response.ok) {
                throw new Error("Failed to fetch data");
            }
            const data = await response.json();
            return data.content.transactionDetails;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchBusinessDetails = async (transactionId) => {
    const token = sessionStorage.getItem("bb_token");
    try {
        let urlParams = `?transactionId=${transactionId}`;
        const apiUrl = BUSINESS_TRANSACTION_DETAILS + urlParams;
        const response = await axios.get(apiUrl, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export const fetchDeleteUserFunc = async (userId, businessTransactionId) => {
  if (!userId || !businessTransactionId) {
    return { error: 'Invalid parameters' };
  }

  try {
    let urlParams = `?userId=${userId}&transactionId=${businessTransactionId}`;
    const apiUrl = DELETE_USER + urlParams;
    const response = await axios.delete(apiUrl);
    return response.data.message;
  } catch (error) {
    console.error("Error making delete request: ", error);
    return { error: error.message, details: error };
  }
};

export const updateBusinessList = async (updatedList) => {
    const url = BUSINESS_LIST_PUT;
    const userToken = sessionStorage.getItem("bb_token") || localStorage.getItem("userToken");
    try {
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${userToken}`,
        },
        body: JSON.stringify(updatedList),
      });

      if (!response.ok) {
        const errData = await response.json().catch(() => null);
        throw new Error(errData?.message || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      throw error;
    }
};

export const updateBusinessStatus = async (businessTransactionId, transactionStatusId) => {
    return updateBusinessList({
        businessTransactionId: Number(businessTransactionId),
        transactionStatusId: Number(transactionStatusId),
    });
};